import { useStore, useStoreActions } from "../../store/store-context";
import { selectors } from "../../store/state-selectors";
import { OAuthProvider } from "../../store/store.model";
import { useIntegration } from "../../hooks/useIntegration";
import { useLocation } from "../../providers/LocationProvider";
import { Accounting } from "../../types/api.model";
import { wait } from "../../infra/utils";
import { integrationModel } from "../../models";
import { useIsMounted } from 'seagull';
const POLLING_TIMEOUT = 2 * 60 * 1000;
const POLLING_INTERVAL = 2000;
export function useQboInVob() {
  const {
    fetchIntegrationsSummary,
    api,
    updateUserClientData,
    fetchUserClientData
  } = useStoreActions();
  const authProvider = useStore(selectors.user.authProvider);
  const showQboStep = authProvider !== OAuthProvider.Intuit;
  const {
    connect: connectToQbo
  } = useIntegration();
  const location = useLocation();
  const isMounted = useIsMounted();
  const connect = async () => {
    const redirectUrl = "http://".concat(window.location.host, "/home");
    const linkUrl = await connectToQbo(redirectUrl);
    if (linkUrl) {
      const connectUrl = new URL(linkUrl);
      connectUrl.searchParams.append('host', window.location.host);
      if (location.assign) location.assign(connectUrl.toString());
    } else {
      await fetchIntegrationsSummary();
    }
  };
  const setPendingConnect = vobQboState => updateUserClientData({
    vobQboState
  });
  const getState = async () => {
    const {
      vobQboState
    } = await fetchUserClientData();
    return vobQboState;
  };
  const getQboAccounts = async () => {
    await waitForReadyIntegration();
    return api.accounting.getAccounts({
      accounting: Accounting.QBO
    });
  };
  async function waitForReadyIntegration() {
    const start = Date.now();
    let integrationsSummary = await fetchIntegrationsSummary();
    while (isMounted() && !((_integrationModel$qbo = integrationModel.qboIntegration(integrationsSummary)) !== null && _integrationModel$qbo !== void 0 && _integrationModel$qbo.isReady()) && Date.now() - start < POLLING_TIMEOUT) {
      var _integrationModel$qbo;
      await wait(POLLING_INTERVAL);
      integrationsSummary = await fetchIntegrationsSummary();
    }
    return integrationModel.qboIntegration(integrationsSummary);
  }
  return {
    showQboStep,
    connect,
    setPendingConnect,
    getState,
    waitForReadyIntegration,
    getQboAccounts
  };
}